export default "__VITE_ASSET__d279ecd7__"